<template>
  <el-dialog
    v-model="isShowDialog"
    :title="formTitle"
    custom-class="user-form"
    :width="getWidth"
    :close-on-click-modal="false"
    @close="clickCancel"
  >
    <slot name="body">
      <h1>本处文本将会被替换(显示了这行字,那么就是不正常的了!)</h1>
    </slot>
    <template #footer>
      <span v-show="!hisSystem" class="dialog-footer">
        <el-button class="cancel-button" @click="clickCancel"> 取 消</el-button>
        <el-button class="confirm-button" @click="confirmBtn">{{ confirmBottomText }}</el-button>
      </span>
    </template>
  </el-dialog>
</template>
<script>
import "@assets/css/Mydialogform.scss";

export default {
  name: "MyDialogForm",
  props: {
    formTitle: {
      type: String,
      default: "标题",
    },
    width: {
      type: Number,
      default: 800,
    },
    confirmBottomText: {
      type: String,
      default: "确 定",
    },
    hisSystem: {
      type: Boolean,
      default: false,
    },

    dialogFormVisible: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["confirmOk"],
  data() {
    return {
      isShowDialog: false
    };
  },
  computed: {
    getWidth() {
      return this.width + "px";
    }
  },
  watch: {
    dialogFormVisible: {
      handler(val) {
        this.isShowDialog = val;
      }
    }
  },
  methods: {
    confirmBtn() {
      // console.log("点击了确定");
      this.$emit("confirmOk", "confirm"); // 发射一个confirmOk事件给父组件,并且穿了confirm给父组件
    },
    clickCancel() {
      // console.log("点击了取消");
      this.$emit("confirmOk", "cancel");
    },
  }
};
</script>

<style lang="scss" scoped>


</style>
